// Status possíveis do atendimento
export enum StatusAtendimento {
  NOVO = 'Novo',
  EM_TRIAGEM = 'Em Triagem (Enfermagem)',
  TRIAGEM_CONCLUIDA = 'Triagem Concluída',
  EM_CONSULTA_GERALISTA = 'Em Consulta Geralista',
  EM_CONSULTA_OFTALMOLOGICA = 'Em Consulta Oftalmológica',
  EM_CONSULTA_RETINOLOGIA = 'Em Consulta Retinologia',
  CONSULTA_CONCLUIDA = 'Consulta Concluída',
  EM_AVALIACAO_CARDIOLOGICA = 'Em Avaliação Cardiológica (Escore Lee)',
  AVALIACAO_CARDIOLOGICA_CONCLUIDA = 'Avaliação Cardiológica Concluída',
  EM_ANAMNESE_PRE_OPERATORIA = 'Em Anamnese Pré-Operatória',
  AGUARDANDO_CIRURGIA = 'Aguardando Cirurgia',
  EM_CIRURGIA = 'Em Cirurgia',
  POS_OPERATORIO = 'Pós-Operatório',
  ATENDIMENTO_CONCLUIDO = 'Atendimento Concluído',
  CANCELADO = 'Cancelado',
  REABERTO = 'Reaberto'
}

// Status padrões que aparecem em todos os formulários
export const STATUS_PADROES = [
  StatusAtendimento.NOVO,
  StatusAtendimento.CANCELADO,
  StatusAtendimento.REABERTO
]

// Mapeamento de formulários para status disponíveis no select
export const FORM_AVAILABLE_STATUSES: Record<string, StatusAtendimento[]> = {
  'Identificação do Paciente': [
    StatusAtendimento.NOVO,
    StatusAtendimento.CANCELADO,
    StatusAtendimento.REABERTO
  ],
  Triagem: [
    StatusAtendimento.EM_TRIAGEM,
    StatusAtendimento.TRIAGEM_CONCLUIDA,
    ...STATUS_PADROES
  ],
  'Prontuário Geralista': [
    StatusAtendimento.EM_CONSULTA_GERALISTA,
    StatusAtendimento.CONSULTA_CONCLUIDA,
    ...STATUS_PADROES
  ],
  'Consulta Oftalmológica': [
    StatusAtendimento.EM_CONSULTA_OFTALMOLOGICA,
    StatusAtendimento.CONSULTA_CONCLUIDA,
    ...STATUS_PADROES
  ],
  'Prontuário Retinólogo': [
    StatusAtendimento.EM_CONSULTA_RETINOLOGIA,
    StatusAtendimento.CONSULTA_CONCLUIDA,
    ...STATUS_PADROES
  ],
  'Avaliação Cardiológica (Escore Lee)': [
    StatusAtendimento.EM_AVALIACAO_CARDIOLOGICA,
    StatusAtendimento.AVALIACAO_CARDIOLOGICA_CONCLUIDA,
    ...STATUS_PADROES
  ],
  'Anamnese Pré-Operatória': [
    StatusAtendimento.EM_ANAMNESE_PRE_OPERATORIA,
    StatusAtendimento.AGUARDANDO_CIRURGIA,
    ...STATUS_PADROES
  ]
}

// Mapeamento de formulários para status
export const FORM_STATUS_MAP: Record<
  string,
  {
    opening: StatusAtendimento
    completion?: StatusAtendimento
  }
> = {
  'Identificação do Paciente': {
    opening: StatusAtendimento.NOVO,
    completion: StatusAtendimento.NOVO
  },
  Triagem: {
    opening: StatusAtendimento.EM_TRIAGEM,
    completion: StatusAtendimento.TRIAGEM_CONCLUIDA
  },
  'Prontuário Geralista': {
    opening: StatusAtendimento.EM_CONSULTA_GERALISTA,
    completion: StatusAtendimento.CONSULTA_CONCLUIDA
  },
  'Consulta Oftalmológica': {
    opening: StatusAtendimento.EM_CONSULTA_OFTALMOLOGICA,
    completion: StatusAtendimento.CONSULTA_CONCLUIDA
  },
  'Prontuário Retinólogo': {
    opening: StatusAtendimento.EM_CONSULTA_RETINOLOGIA,
    completion: StatusAtendimento.CONSULTA_CONCLUIDA
  },
  'Avaliação Cardiológica (Escore Lee)': {
    opening: StatusAtendimento.EM_AVALIACAO_CARDIOLOGICA,
    completion: StatusAtendimento.AVALIACAO_CARDIOLOGICA_CONCLUIDA
  },
  'Anamnese Pré-Operatória': {
    opening: StatusAtendimento.EM_ANAMNESE_PRE_OPERATORIA,
    completion: StatusAtendimento.AGUARDANDO_CIRURGIA
  }
}
